<template>
  <v-dialog
    :model-value="dialog"
    content-class="i-dialog"
    width="400"
    @click:outside="handleCancel"
    @keydown.esc="handleCancel"
  >
    <v-card>
      <template>
        <v-card-title class="i-dialog-header-div">
          <span class="g-heading-m g-bold">{{ title }}</span>
        </v-card-title>

        <v-card-text class="py-4 text-center">
          <p v-html="text"></p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center">
          <v-btn rounded text class="i-btn-text-black" @click="handleCancel">
            <strong>Cancel</strong>
          </v-btn>

          <v-btn rounded class="i-btn-block-secondary" @click="handleConfirm">
            <strong>{{ $filters.sentenceCase(action) }}</strong>
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      default: false,
      type: Boolean
    },

    action: {
      required: true,
      type: String
    },

    text: {
      required: true,
      type: String
    },

    title: {
      default: 'Confirmation',
      type: String
    }
  },

  methods: {
    handleCancel() {
      this.$emit('cancel')
    },

    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
